import { S } from '../../core/store.js';
import { $ } from '../../core/util.js';
import { vChat } from './view.js';
import { actions } from './actions.js';

export default {
  id: 'chat', label: 'Chat', icon: 'chat', nav: true, show: () => true,
  view: vChat, actions,
  badge: () => Object.values(S.unread).reduce((a, b) => a + b, 0),
  enters: { send: () => actions.send() },
  afterRender() { const ms = $('#msgs'); if (ms) ms.scrollTop = ms.scrollHeight; }
};
